import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { AutoAwesomeOutlined as MRLIcon } from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { LOTTERY_NAMES, LOTTERY_TYPES } from "../../../../../static/Constants";
import { NoData, CommonButton } from "../../../../Components/ui";

const MegaLotteryEmptyState = ({ onReset, hasActiveFilters = false }) => {
  const megaTheme = LOTTERY_TYPES[2];

  return (
    <Box
      sx={{
        bgcolor: colors.dashboard.cardBg,
        borderRadius: borderRadiusPx.xl,
        border: `1px solid ${colors.dashboard.cardBorder}`,
        p: { xs: 4, md: 6 },
        textAlign: "center",
        my: 3,
      }}
    >
      <NoData
        icon={<MRLIcon sx={{ fontSize: 36, color: megaTheme.color }} />}
        title={hasActiveFilters ? `No Matching ${LOTTERY_NAMES.MEGABET} Games Found` : `No Active ${LOTTERY_NAMES.MEGABET} Lotteries !`}
        subtitle={
          hasActiveFilters
            ? `Try adjusting your search terms or clearing your filters to discover open ${LOTTERY_NAMES.MEGABET} games.`
            : `There are currently no active ${LOTTERY_NAMES.MEGABET} lotteries open. Please check back shortly or explore other lottery games!`
        }
        paper={false}
      />
      {hasActiveFilters && onReset && (
        <Box sx={{ mt: 2 }}>
          <CommonButton
            variant="primary"
            size="small"
            onClick={onReset}
            label="Reset Search Filters"
            sx={{
              bgcolor: megaTheme.color,
              "&:hover": { bgcolor: megaTheme.darkColor },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

MegaLotteryEmptyState.propTypes = {
  onReset: PropTypes.func,
  hasActiveFilters: PropTypes.bool,
};

export default MegaLotteryEmptyState;
